import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import api_service from "../../api/api_service";

const GeometrySubMenu = ({ selectedGeom, editableGeom, onClose, onGeomUpdate}) => {
    const [editedGeom, setEditedGeom] = useState(editableGeom);
    const [textFieldValues, setTextFieldValues] = useState({
        name: editableGeom.name || "New",
        properties: JSON.stringify(editableGeom.properties, null, 2),
        geometry: JSON.stringify(editableGeom.geometry, null, 2),
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        setEditedGeom(editableGeom);
        setTextFieldValues({
        name: editableGeom.name || "New",
        properties: JSON.stringify(editableGeom.properties || {}, null, 2),
        geometry: JSON.stringify(editableGeom.geometry, null, 2),
        });
        setErrors({});
    }, [editableGeom]);

    const handleInputChange = (field, value) => {
        setTextFieldValues((prevValues) => ({
        ...prevValues,
        [field]: value,
        }));
        setErrors((prevErrors) => ({ ...prevErrors, [field]: null }));
    };

    const handleSave = async () => {
        const newErrors = {};
        try {
        JSON.parse(textFieldValues.properties);
        } catch (error) {
        newErrors.properties = error.message;
        }
        try {
        JSON.parse(textFieldValues.geometry);
        } catch (error) {
        newErrors.geometry = error.message;
        }

        if (Object.keys(newErrors).length === 0) {

            const updatedGeom = {
                name: textFieldValues.name || "New",
                properties: JSON.parse(textFieldValues.properties),
                geometry: JSON.parse(textFieldValues.geometry),
                };

                if (selectedGeom.geom_id) {
                    var response = await api_service.updateGeom(
                        selectedGeom.geom_id,
                        updatedGeom
                        );
                }
                else {
                    var response = await api_service.createGeom(
                        updatedGeom
                        );
                    }
                    
                onGeomUpdate(response.json()); 
            
            } else {
                setErrors(newErrors)
            }

    };

    if (!selectedGeom) {
        return null;
    }

    return (
        <AnimatePresence>
        <motion.div
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.3 }}
            style={{}}
        >
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
            </div>
            <div style={{ textAlign: "left", marginLeft: "10px" }}>
            <div>
                <div>
                <TextField
                    label="geom_name"
                    value={textFieldValues.name}
                    onChange={(e) => handleInputChange("name", e.target.value)}
                    fullWidth
                    margin="normal"
                />

                <TextField
                    label="properties"
                    multiline
                    rows={4}
                    value={textFieldValues.properties}
                    onChange={(e) => handleInputChange("properties", e.target.value)}
                    fullWidth
                    margin="normal"
                    error={!!errors.properties}
                    helperText={errors.properties}
                />

                <TextField
                    label="geom"
                    multiline
                    rows={20}
                    value={textFieldValues.geometry}
                    onChange={(e) => handleInputChange("geometry", e.target.value)}
                    fullWidth
                    margin="normal"
                    error={!!errors.geometry}
                    helperText={errors.geometry}
                />

                <Button variant="contained" color="primary" onClick={handleSave}>
                    Save
                </Button>
                </div>
            </div>
            </div>
        </motion.div>
        </AnimatePresence>
    );
};

export default GeometrySubMenu;
